import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasRole, ROLES } from '../utils/rbac';

const AdminRoute = ({ isAuthenticated, user, children }) => {
  // Check if user is authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated but user data is still loading, show loading
  if (!user) {
    return <div className="loading">Loading...</div>;
  }

  // Check if user has super_admin role - strict check
  if (user.user_type !== ROLES.SUPER_ADMIN) {
    // Not a super admin - redirect to home
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
